import { Injectable, inject } from '@angular/core';
import { SessionExpiryService } from './session-expiry.service';
import { getCookie } from '../utils/cookie.utils';

@Injectable({
  providedIn: 'root'
})
export class SessionInitializationService {
  private sessionExpiryService = inject(SessionExpiryService);

  constructor() {
    this.initializeSessionMonitoring();
  }

  private initializeSessionMonitoring(): void {
    const token = getCookie('auth_token');
    const refreshToken = getCookie('refresh_token');
    if (token || refreshToken) {
      console.log('Initializing persistent session monitoring');
      this.sessionExpiryService.startMonitoring({
        warningTimeMinutes: 3,
        checkIntervalMinutes: 2
      });
    } else {
      console.log('No token found, skipping session monitoring initialization');
    }
  }
}
